import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-320fc0aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "top-container" }
const _hoisted_3 = { class: "navlist" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "title" }, "dashboard", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "title" }, "bookings", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "title" }, "apartments", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "title" }, "repairs", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "title" }, "finance", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "title" }, "settings", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-right-from-bracket" })
], -1))
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideMenu()))
      }, " X ")
    ]),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hideMenu'))),
          to: { name: 'Dashboard', params: { building: _ctx.$route.params.building } },
          class: "aside-link"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: { name: 'Calendar', params: { building: _ctx.$route.params.building } },
          class: "aside-link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('hideMenu')))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('hideMenu'))),
          to: { name: 'Apartments', params: { building: _ctx.$route.params.building } },
          class: "aside-link"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('hideMenu'))),
          to: { name: 'Repairs', params: { building: _ctx.$route.params.building } },
          class: "aside-link"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: { name: 'Payments', params: { building: _ctx.$route.params.building } },
          class: "aside-link"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('hideMenu'))),
          to: { name: 'Settings', params: { building: _ctx.$route.params.building } },
          class: "aside-link"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.logout()))
        }, [
          _hoisted_10,
          _createElementVNode("h6", _hoisted_11, [
            (!_ctx.outing)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "logout"))
              : _createCommentVNode("", true),
            (_ctx.outing)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "logging out"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}